// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bg69","label":"styles_label__3KjQ0"};